import script from "./OnboardingHub.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingHub.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingHub.vue?vue&type=style&index=0&id=5a154575&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a154575"]])

export default __exports__